import React, { FunctionComponent } from 'react';
import { Route } from 'react-router-dom';

import { DatePickerProvider } from 'components/DatePicker/DatePicker.context';
import { useUserMgmt } from 'components/UserMgmt/UserMgmt.context';
import Header from 'components/Header';
import Footer from 'components/Footer';

import NotFound from 'scenes/NotFound';

import { ExternalRoutes, InternalRoutes } from 'Routes';

const Routes: FunctionComponent = () => {
  const { isInternalUser, isExternalUser } = useUserMgmt();

  return (
    <>
      <DatePickerProvider>
        <Route path="*" component={Header} />
        {isExternalUser && <ExternalRoutes />}
        {isInternalUser && <InternalRoutes />}
      </DatePickerProvider>
      {!isExternalUser && !isInternalUser && <Route component={NotFound} />}
      <Footer />
    </>
  );
};
export default Routes;
